import { Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import Typography from '@mui/material/Typography';
import SharepointLink from '../../Global/SharepointLink/SharepointLink';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import GlobalStyles from '@mui/material/GlobalStyles';

const scopedTheme = createTheme();

const CategoryAccordion = ({ category, index, baseUrl }) => {
  return (
    <ThemeProvider theme={scopedTheme}>
      <GlobalStyles
        styles={{
          '.MuiAccordionSummary-root': {
            backgroundColor: '#0075BF !important',
            width: '100%',
            '@media (max-width:600px)': {
              backgroundColor: '#0075BF !important',
            },
          },
          '.MuiButtonBase-root': {
            padding: '0 1rem !important',
          },
        }}
      />
      <div className="m-2 software-list-wrapper">
        <Accordion defaultExpanded sx={{ backgroundColor: '#f2f2f2' }}>
          <AccordionSummary
            id={`panel-${index}`}
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-${index}-content`}
          >
            <Typography sx={{ color: '#fff' }}>{category.name}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ul>
              {category.children.map((item) => (
                <li className="d-flex align-items-center" key={item.Title}>
                  <Box sx={{ width: '40px', height: 'auto' }}>
                    <LaunchOutlinedIcon />
                  </Box>
                  <SharepointLink
                    linkType={item.LinkTypeID}
                    link={item.Link}
                    fileName=""
                    baseUrl={baseUrl}
                  >
                    {item.Title}
                  </SharepointLink>
                </li>
              ))}
            </ul>
          </AccordionDetails>
        </Accordion>
      </div>
    </ThemeProvider>
  );
};

export default CategoryAccordion;
